import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export type DeviceState = {
	isMobile: boolean
	isTablet: boolean
}

const initialState: DeviceState = {
	isMobile: false,
	isTablet: false,
}

export namespace DeviceNS {
	export type setIsMobile = PayloadAction<boolean>
	export type setIsTablet = PayloadAction<boolean>
}

export const deviceSlice = createSlice({
	name: 'device',
	initialState,
	reducers: {
		setIsMobile: (state, action: DeviceNS.setIsMobile) => {
			state.isMobile = action.payload
		},
		setIsTablet: (state, action: DeviceNS.setIsTablet) => {
			state.isTablet = action.payload
		},
	},
})
